export const tr = {
    more: 'Daha fazla bilgi',
    'not-meet-requirements': 'Koşullara uygun değil',
    repeat: 'Tekrar dene',
    uploading: 'Yükleniyor'
};
